// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style__tabs__4gtBC","vertical":"style__vertical__r9sD4","tabsLeft":"style__tabsLeft__m5U-g"};